// jQuery
jQuery(function ($) {
    // -----------------------------
    // totop
    // -----------------------------
    // ボタンをクリックしたらスクロールして上に戻る
    var topBtn = $('.totop');

    topBtn.on("click", function () {
        $('body,html').animate({
            scrollTop: 0
        }, 300, 'swing');
        return false;
    });
});

// JavaScript


// -----------------------------
// HEADER
// -----------------------------
$(function () {
    // dropdown language
    $('.drowpdown-language__button').on('mouseenter', function () {
        dropdownOpen = true;
        gsap.fromTo(".drowpdown-language__items",
            { y: 0, opacity: 0, visibility: "hidden" },
            { y: 20, opacity: 1, visibility: "visible", duration: 0.3 }
        );
    });

    $('.drowpdown-language__items').on('mouseenter', function () {
        dropdownOpen = true;

    });

    $('.drowpdown-language__button, .drowpdown-language__items').on('mouseleave', function () {
        dropdownOpen = false;

        setTimeout(function () {
            if (!dropdownOpen) {
                gsap.fromTo(".drowpdown-language__items",
                    { y: 20, opacity: 1, visibility: "visible" },
                    { y: 0, opacity: 0, visibility: "hidden", duration: 0.3 }
                );
            }
        }, 100);
    });


    // dropdown menu
    $('.menu-item, .dropdown-menu').on('mouseenter', function () {
        menuId = $(this).data('menu');

        if (menuId <= 6) {
            $('#menu-' + menuId).addClass('menu-bottom-active');
        } else {
            $('#menu-' + menuId).addClass('menu-top-active');
        }

        $('.dropdown-menu').removeClass('dropdown-active');
        $('#dropdown-' + menuId).addClass('dropdown-active');
    });

    $('.menu-item, .dropdown-menu').on('mouseleave', function () {
        menuId = $(this).data('menu');

        setTimeout(function () {
            if (!$('#dropdown-' + menuId).is(':hover') && !$('#menu-' + menuId).is(':hover')) {
                $('#dropdown-' + menuId).removeClass('dropdown-active');
                $('#menu-' + menuId).removeClass('menu-bottom-active');
                $('#menu-' + menuId).removeClass('menu-top-active');
            }
        }, 300);
    });

    $('.menu-item').on('mouseleave', function () {
        $('.menu-item').removeClass('menu-bottom-active');
        $('.menu-item').removeClass('menu-top-active');
    });



    //SP
    $('.header-sp__menu').on('click', function () {
        $(this).toggleClass('menu-active');

        var tl = gsap.timeline();
        if ($(this).hasClass('menu-active')) {
            tl.fromTo('.menu-overlay', { x: '200%' }, { x: 0, duration: 1.5, ease: 'power2.out' });
            $("body").toggleClass("remove-body-scroll");
        } else {
            $("body").toggleClass("remove-body-scroll");

            tl.fromTo('.menu-overlay', { x: 0 }, { x: '200%', duration: 1.5, ease: 'power2.out' });
        }
    });


});

function redirectWP($url) {
    window.location.href = $url;
}

// -----------------------------
// COMPONENTS
// -----------------------------
$(function () {

    // BANNER HEADER
    if ($('.banner-header__img').length) {
        if ($(window).width() > 919) {
            gsap.registerPlugin(ScrollTrigger);
            gsap.to(".banner-header__img", {
                width: '100vw',
                height: '100%',
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".banner-header",
                    start: "top-=300 top",
                    end: "+=200",
                    scrub: true,
                }
            });
        } else {
            gsap.registerPlugin(ScrollTrigger);
            gsap.to(".banner-header__img", {
                width: '100vw',
                height: '100%',
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: ".banner-header",
                    start: "top-=220 top",
                    end: "+=200",
                    scrub: true,
                }
            });
        }
    }


    // ACCORDION
    $('.accordion.single').on('click', function () {
        $('.accordion.single').not(this).removeClass('accordion-active');

        $(this).toggleClass('accordion-active');
        accBody = $(this).find('.accordion-body');
        if (accBody.css('max-height') !== '0px' && accBody.css('max-height') !== 'none') {
            accBody.css('max-height', '0');
        } else {
            $('.accordion-body').css('max-height', '0');
            accBody.animate({ maxHeight: accBody[0].scrollHeight + "px" }, 200);
        }
    });

    $('.accordion.multi').on('click', function () {
        $(this).toggleClass('accordion-active');

        const accBody = $(this).find('.accordion-body');
        if (accBody.css('max-height') !== '0px' && accBody.css('max-height') !== 'none') {
            accBody.css('max-height', '0');
        } else {
            accBody.css('max-height', accBody[0].scrollHeight + "px");
        }
    });


    //TABS 
    // 例：
    $('.tabsParts-btn').on('click', function () {
        $('.tabsParts-btn').not(this).removeClass('tab-active');
        id = $(this).data('id');
        $(this).addClass('tab-active');


        $('.tabsParts-content').removeClass('tabs-content-active');
        $('#tabs-content-' + id).addClass('tabs-content-active');

    });

    // 例：
    $('.tabs2Parts-btn').on('click', function () {
        $('.tabs2Parts-btn').not(this).removeClass('tab-active');
        id = $(this).data('id');
        $(this).addClass('tab-active');


        $('.tabs2Parts-content').removeClass('tabs2-content-active');
        $('#tabs2-content-' + id).addClass('tabs2-content-active');

    });

    $('.tabs3-btn').on('click', function () {
        $('.tabs3-btn').not(this).removeClass('tab-active');
        id = $(this).data('id');
        $(this).addClass('tab-active');


        $('.tabs3-content').removeClass('tabs3-content-active');
        $('#tabs3-content-' + id).addClass('tabs3-content-active');

    });

    // POPUP
    $('.open-popup-link').magnificPopup({
        type: 'inline',
        midClick: true,
    });
});

// ------------------------------
// ScrollHint
// ------------------------------
document.addEventListener("DOMContentLoaded", function () {
    new ScrollHint(".js-scrollable", {
        scrollHintIconAppendClass: "scroll-hint-icon-white",
        i18n: {
            scrollable: "スクロールできます",
        },
    });
});

// 使い方
//<div class="js-scrollable">
//  <table>
//    ~~~
//  </table>
//</div>

// -----------------------------
// TOP
// -----------------------------
$(function () {

    // mv
    if ($(".mv").length) {
        $("body").on("touchstart click", function () {
            $("#mv-video").get(0).play();
        });

        var videoObserver = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                $("#mv-video").get(0).play();
            } else {
                // console.log('not visible');
                $("#mv-video").get(0).pause();
            }
        }, { threshold: [0] });
        videoObserver.observe(document.querySelector(".mv-video"));
    }

    // gallery
    $('.gallery__slick').slick({
        autoplay: true,         //自動再生
        autoplaySpeed: 0,       //自動再生のスピード
        speed: 11000,            //スライドスピード
        slidesToShow: 3,        //スライドの表示枚数
        cssEase: "linear",      //スライドの動きを等速に
        pauseOnHover: false,    //ホバーしても止まらないように
        pauseOnFocus: false,
        arrows: false,
        variableWidth: true
    });

    // parallax background
    if ($(".eventnews__content").length) {
        var lastScrollTopEN = 0;
        var positionEN = $(".eventnews__content").position().top;

        var visibleEN = false;
        //verify element is visible in viewport
        var observerEN = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleEN = true;
            } else {
                // console.log('not visible');
                visibleEN = false;
            }
        }, { threshold: [0] });
        observerEN.observe(document.querySelector("#eventnews"));

        $(window).on("scroll", function () {
            if (visibleEN) {
                var scrollTopEN = $(this).scrollTop();

                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopEN > lastScrollTopEN) {
                        // downscroll code
                        positionEN -= 2.5;
                    } else {
                        // upscroll code
                        positionEN += 2.5;
                    }
                    lastScrollTopEN = scrollTopEN;
                    $(".eventnews__bg-parallax").css("transform", "translateY(" + positionEN + "px)");
                } else {
                    //MOBILE
                    if (scrollTopEN > lastScrollTopEN) {
                        // downscroll code
                        positionEN -= 0.8;
                    } else {
                        // upscroll code
                        positionEN += 0.8;
                    }
                    lastScrollTopEN = scrollTopEN;
                    $(".eventnews__bg-parallax").css("transform", "translateY(" + positionEN + "px)");
                }
            } else {
                lastScrollTopEN = 0;
                positionEN = $(".eventnews__content").position().top;
            }
        });

    }

    if ($(".knowledge__content").length) {
        var lastScrollTopK = 0;
        var positionK = $(".knowledge__content").position().top;

        var visibleK = false;
        //verify element is visible in viewport
        var observerKnowledge = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleK = true;
            } else {
                // console.log('not visible');
                visibleK = false;
            }
        }, { threshold: [0] });
        observerKnowledge.observe(document.querySelector("#knowledge"));

        $(window).on("scroll", function () {
            if (visibleK) {
                var scrollTopK = $(this).scrollTop();

                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopK > lastScrollTopK) {
                        // downscroll code
                        positionK -= 2.5;
                    } else {
                        // upscroll code
                        positionK += 2.5;
                    }
                    lastScrollTopK = scrollTopK;
                    $(".knowledge__bg-parallax").css("transform", "translateY(" + positionK + "px)");
                } else {
                    //MOBILE
                    if (scrollTopK > lastScrollTopK) {
                        // downscroll code
                        positionK -= 0.8;
                    } else {
                        // upscroll code
                        positionK += 0.8;
                    }
                    lastScrollTopK = scrollTopK;
                    $(".knowledge__bg-parallax").css("transform", "translateY(" + positionK + "px)");
                }
            } else {
                lastScrollTopK = 0;
                positionK = $(".knowledge__content").position().top;
            }
        });

    }

    if ($(".experience-cafe__content").length) {
        var lastScrollTopEC = 0;
        var positionEC = $(".experience-cafe__content").position().top;

        var visibleEC = false;
        //verify element is visible in viewport
        var observerEC = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleEC = true;
            } else {
                // console.log('not visible');
                visibleEC = false;
            }
        }, { threshold: [0] });
        observerEC.observe(document.querySelector("#experience-cafe"));

        $(window).on("scroll", function () {
            if (visibleEC) {
                var scrollTopEC = $(this).scrollTop();

                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopEC > lastScrollTopEC) {
                        // downscroll code
                        positionEC -= 2.5;
                    } else {
                        // upscroll code
                        positionEC += 2.5;
                    }
                    lastScrollTopEC = scrollTopEC;
                    $(".experience-cafe__bg-parallax").css("transform", "translateY(" + positionEC + "px)");
                } else {
                    //MOBILE
                    if (scrollTopEC > lastScrollTopEC) {
                        // downscroll code
                        positionEC -= 0.8;
                    } else {
                        // upscroll code
                        positionEC += 0.8;
                    }
                    lastScrollTopEC = scrollTopEC;
                    $(".experience-cafe__bg-parallax").css("transform", "translateY(" + positionEC + "px)");
                }
            } else {
                lastScrollTopEC = 0;
                positionEC = $(".experience-cafe__content").position().top;
            }
        });

    }

    if ($(".column__content").length) {
        var lastScrollTopColumn = 0;
        var positionColumn = $(".column__content").position().top;

        var visibleColumn = false;
        //verify element is visible in viewport
        var observerColumn = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleColumn = true;
            } else {
                // console.log('not visible');
                visibleColumn = false;
            }
        }, { threshold: [0] });
        observerColumn.observe(document.querySelector("#column"));

        $(window).on("scroll", function () {
            if (visibleColumn) {
                var scrollTopColumn = $(this).scrollTop();

                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopColumn > lastScrollTopColumn) {
                        // downscroll code
                        positionColumn -= 2.5;
                    } else {
                        // upscroll code
                        positionColumn += 2.5;
                    }
                    lastScrollTopColumn = scrollTopColumn;
                    $(".column__bg-parallax").css("transform", "translateY(" + positionColumn + "px)");
                } else {
                    //MOBILE
                    if (scrollTopColumn > lastScrollTopColumn) {
                        // downscroll code
                        positionColumn -= 0.8;
                    } else {
                        // upscroll code
                        positionColumn += 0.8;
                    }
                    lastScrollTopColumn = scrollTopColumn;
                    $(".column__bg-parallax").css("transform", "translateY(" + positionColumn + "px)");
                }
            } else {
                lastScrollTopColumn = 0;
                positionColumn = $(".column__content").position().top;
            }
        });

    }

    if ($(".sns__content").length) {
        var lastScrollTopSNS = 0;
        var positionSNS = $(".sns__content").position().top;

        var visibleSNS = false;
        //verify element is visible in viewport
        var observerSNS = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleSNS = true;
            } else {
                // console.log('not visible');
                visibleSNS = false;
            }
        }, { threshold: [0] });
        observerSNS.observe(document.querySelector("#sns"));

        $(window).on("scroll", function () {
            if (visibleSNS) {
                var scrollTopSNS = $(this).scrollTop();

                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopSNS > lastScrollTopSNS) {
                        // downscroll code
                        positionSNS -= 2.5;
                    } else {
                        // upscroll code
                        positionSNS += 2.5;
                    }
                    lastScrollTopSNS = scrollTopSNS;
                    $(".sns__bg-parallax").css("transform", "translateY(" + positionSNS + "px)");
                } else {
                    //MOBILE
                    if (scrollTopSNS > lastScrollTopSNS) {
                        // downscroll code
                        positionSNS -= 0.8;
                    } else {
                        // upscroll code
                        positionSNS += 0.8;
                    }
                    lastScrollTopSNS = scrollTopSNS;
                    $(".sns__bg-parallax").css("transform", "translateY(" + positionSNS + "px)");
                }
            } else {
                lastScrollTopSNS = 0;
                positionSNS = $(".sns__content").position().top;
            }
        });

    }

    if ($(".column__content2").length) {
        var lastScrollTopColumn2 = 0;
        var positionColumn2 = $(".column__content2").position().top
        var visibleColumn2 = false;
        //verify element is visible in viewport
        var observerColumn2 = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleColumn2 = true;
            } else {
                // console.log('not visible');
                visibleColumn2 = false;
            }
        }, { threshold: [0] });
        observerColumn2.observe(document.querySelector("#column2"))
        $(window).on("scroll", function () {
            if (visibleColumn2) {
                var scrollTopColumn2 = $(this).scrollTop()
                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopColumn2 > lastScrollTopColumn2) {
                        // downscroll code
                        positionColumn2 -= 2.5;
                    } else {
                        // upscroll code
                        positionColumn2 += 2.5;
                    }
                    lastScrollTopColumn2 = scrollTopColumn2;
                    $(".column__bg-parallax2").css("transform", "translateY(" + positionColumn2 + "px)");
                } else {
                    //MOBILE
                    if (scrollTopColumn2 > lastScrollTopColumn2) {
                        // downscroll code
                        positionColumn2 -= 0.8;
                    } else {
                        // upscroll code
                        positionColumn2 += 0.8;
                    }
                    lastScrollTopColumn2 = scrollTopColumn2;
                    $(".column__bg-parallax2").css("transform", "translateY(" + positionColumn2 + "px)");
                }
            } else {
                lastScrollTopColumn2 = 0;
                positionColumn2 = $(".column__content2").position().top;
            }
        })
    }

    if ($(".column__content3").length) {
        var lastScrollTopColumn3 = 0;
        var positionColumn3 = $(".column__content3").position().top
        var visibleColumn3 = false;
        //verify element is visible in viewport
        var observerColumn3 = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleColumn3 = true;
            } else {
                // console.log('not visible');
                visibleColumn3 = false;
            }
        }, { threshold: [0] });
        observerColumn3.observe(document.querySelector("#column3"))
        $(window).on("scroll", function () {
            if (visibleColumn3) {
                var scrollTopColumn3 = $(this).scrollTop()
                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopColumn3 > lastScrollTopColumn3) {
                        // downscroll code
                        positionColumn3 -= 2.5;
                    } else {
                        // upscroll code
                        positionColumn3 += 2.5;
                    }
                    lastScrollTopColumn3 = scrollTopColumn3;
                    $(".column__bg-parallax3").css("transform", "translateY(" + positionColumn3 + "px)");
                } else {
                    //MOBILE
                    if (scrollTopColumn3 > lastScrollTopColumn3) {
                        // downscroll code
                        positionColumn3 -= 0.8;
                    } else {
                        // upscroll code
                        positionColumn3 += 0.8;
                    }
                    lastScrollTopColumn3 = scrollTopColumn3;
                    $(".column__bg-parallax3").css("transform", "translateY(" + positionColumn3 + "px)");
                }
            } else {
                lastScrollTopColumn3 = 0;
                positionColumn3 = $(".column__content3").position().top;
            }
        })
    }

    if ($(".column__content4").length) {
        var lastScrollTopColumn4 = 0;
        var positionColumn4 = $(".column__content4").position().top
        var visibleColumn4 = false;
        //verify element is visible in viewport
        var observerColumn4 = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleColumn4 = true;
            } else {
                // console.log('not visible');
                visibleColumn4 = false;
            }
        }, { threshold: [0] });
        observerColumn4.observe(document.querySelector("#column4"))
        $(window).on("scroll", function () {
            if (visibleColumn4) {
                var scrollTopColumn4 = $(this).scrollTop()
                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopColumn4 > lastScrollTopColumn4) {
                        // downscroll code
                        positionColumn4 -= 2.5;
                    } else {
                        // upscroll code
                        positionColumn4 += 2.5;
                    }
                    lastScrollTopColumn4 = scrollTopColumn4;
                    $(".column__bg-parallax4").css("transform", "translateY(" + positionColumn4 + "px)");
                } else {
                    //MOBILE
                    if (scrollTopColumn4 > lastScrollTopColumn4) {
                        // downscroll code
                        positionColumn4 -= 0.8;
                    } else {
                        // upscroll code
                        positionColumn4 += 0.8;
                    }
                    lastScrollTopColumn4 = scrollTopColumn4;
                    $(".column__bg-parallax4").css("transform", "translateY(" + positionColumn4 + "px)");
                }
            } else {
                lastScrollTopColumn4 = 0;
                positionColumn4 = $(".column__content4").position().top;
            }
        })
    }

    if ($(".column__content5").length) {
        var lastScrollTopColumn5 = 0;
        var positionColumn5 = $(".column__content5").position().top
        var visibleColumn5 = false;
        //verify element is visible in viewport
        var observerColumn5 = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                visibleColumn5 = true;
            } else {
                // console.log('not visible');
                visibleColumn5 = false;
            }
        }, { threshold: [0] });
        observerColumn5.observe(document.querySelector("#column5"))
        $(window).on("scroll", function () {
            if (visibleColumn5) {
                var scrollTopColumn5 = $(this).scrollTop()
                if ($(window).width() > 640) {
                    //PC
                    if (scrollTopColumn5 > lastScrollTopColumn5) {
                        // downscroll code
                        positionColumn5 -= 2.5;
                    } else {
                        // upscroll code
                        positionColumn5 += 2.5;
                    }
                    lastScrollTopColumn5 = scrollTopColumn5;
                    $(".column__bg-parallax5").css("transform", "translateY(" + positionColumn5 + "px)");
                } else {
                    //MOBILE
                    if (scrollTopColumn5 > lastScrollTopColumn5) {
                        // downscroll code
                        positionColumn5 -= 0.8;
                    } else {
                        // upscroll code
                        positionColumn5 += 0.8;
                    }
                    lastScrollTopColumn5 = scrollTopColumn5;
                    $(".column__bg-parallax5").css("transform", "translateY(" + positionColumn5 + "px)");
                }
            } else {
                lastScrollTopColumn5 = 0;
                positionColumn5 = $(".column__content5").position().top;
            }
        })
    }
});

// -----------------------------
// qaのサイドバー
// -----------------------------
document.addEventListener("DOMContentLoaded", function () {
    // カテゴリリンクのクリックイベントを設定
    const categoryLinks = document.querySelectorAll('.qa__categories a');

    categoryLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault(); // ページ遷移を防ぐ

            // すべてのリンクから --active クラスを削除
            categoryLinks.forEach(l => l.classList.remove('--active'));

            // クリックされたリンクに --active クラスを追加
            this.classList.add('--active');

            // 対応するコンテンツにスクロール（任意）
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });

            }
        });
    });
});

// -----------------------------
// 内部リンクの遷移したときにヘッダー分を足す
// -----------------------------
$(function () {
    $('a[href^="#"]').click(function () {//href属性に#を含むaタグをクリックした時
        if ($(this).hasClass('popup')) return;

        var href = $(this).attr("href");//クリックした要素のhref属性を取得
        var target = $(href == "#" || href == "" ? 'html' : href);//リンク先を取得
        var position = target.offset().top - 120;//リンク先までの距離を取得
        $("html, body").animate({ scrollTop: position }, 300);//スムーススクロール
        return false;
    });
});

// -----------------------------
// GALLERY
// -----------------------------
$(function () {
    $('.filter__tags-item').on("click", function () {
        $(this).toggleClass('selected-tag');
    });

    $('.filter__tags-item').on('click', function () {
        // get selected tags
        const selectedItems = $('.filter__tags-item.selected-tag').map(function () {
            var tag = $(this).data('slug');
            return tag;
        }).get();

        const currentUrl = new URL(window.location.href);
        const params = new URLSearchParams(currentUrl.search);
        var newUrl = `${currentUrl.origin}${currentUrl.pathname}`;

        if (selectedItems.length > 0) {
            const tags = selectedItems.map(tag => tag.replace('#', '')).join(',');
            params.set('tags', tags);
            newUrl = `${currentUrl.origin}${currentUrl.pathname}?${decodeURIComponent(params.toString())}`;
        }
        window.location.href = newUrl+"#filter";
    });

    var urlParams = new URLSearchParams(window.location.search);

    if (window.location.hash) {
        if ($(window.location.hash).length) {
            $('body,html').animate({
                scrollTop: $(window.location.hash).offset().top - 100
            }, 300, 'swing');
            return false;
        }
    }

    if (urlParams.toString() !== "") {

        if ($('#posts').length) {
            $('body,html').animate({
                scrollTop: $('#posts').offset().top - 100
            }, 300, 'swing');
            return false;
        }
    }

    if ($('#media').length) {
        const choices = new Choices('#media', {
            searchEnabled: true,
            removeItemButton: true,
            itemSelectText: ''
        });
    }

});

$(window).on('load', function () {
    if ($(window).width() <= 919) {
        $(".post-videos").each(function () {
            // $(this).attr('controls', 'controls');
            this.load();
            this.currentTime = 0.1;
        });
    }

    $(document).on('mouseenter', '.post-videos', function () {
        $(this).attr('controls', 'controls');
    });

    $(document).on('mouseleave', '.post-videos', function () {
        $(this).removeAttr('controls');
    });
});


// ------------------------------
// 会員ページ - PDF
// ------------------------------
$(function () {
    const { jsPDF } = window.jspdf;

    $(document).on('click', '#generate-calendar-pdf', function () {
        html2canvas(document.querySelector("#pdf-content"), {
            windowWidth: 1200,
            logging: false,
        }).then(canvas => {
            // convert canvas to base64 image
            var imgData = canvas.toDataURL('image/png');

            // new pdf
            var doc = new jsPDF();

            // get pdf dimensions
            var pdfWidth = doc.internal.pageSize.getWidth();
            var pdfHeight = doc.internal.pageSize.getHeight();

            // get images dimensions (original proportion)
            var imgWidth = canvas.width;
            var imgHeight = canvas.height;

            // calculate original proportion
            var ratio = imgWidth / imgHeight;

            // set margim
            var margin = 24;

            // calculate new width and height based on PDF width
            var newWidth = pdfWidth - 2 * margin;
            var newHeight = newWidth / ratio;

            // If the adjusted height is greater than the PDF height, we adjust the height
            if (newHeight > pdfHeight - 2 * margin) {
                newHeight = pdfHeight - 2 * margin;
                newWidth = newHeight * ratio;
            }

            // calculate x position to center image
            var xPos = margin;

            // calculate x position to center image
            var yPos = margin;

            // add image to PDF with new dimensions
            doc.addImage(imgData, 'PNG', xPos, yPos, newWidth, newHeight);

            // save PDF
            doc.save('カレンダー.pdf');
        }).catch(error => {
            console.error('PDF error:', error);
        });
    });
});

// -----------------------------
// 宇治茶の美味しい淹れ方、楽しみ方
// -----------------------------
$(function () {

    $('.tabsBrew-btn').on('click', function () {
        $('.tabsBrew-btn').not(this).removeClass('tab-active');
        id = $(this).data('id');
        $(this).addClass('tab-active');


        $('.tabsBrew-content').removeClass('tabs-content-active');
        $('#tabsBrew-content-' + id).addClass('tabs-content-active');

    });

    $('.tabsEnjoy-btn').on('click', function () {
        $('.tabsEnjoy-btn').not(this).removeClass('tab-active');
        id = $(this).data('id');
        $(this).addClass('tab-active');


        $('.tabsEnjoy-content').removeClass('tabs-content-active');
        $('#tabsEnjoy-content-' + id).addClass('tabs-content-active');

    });

});

// -----------------------------
// 宇治茶の美味しい淹れ方、楽しみ方 - 買える店
// -----------------------------
$(function () {
    $(window).on("scroll", function () {
        let scrollPos = $(window).scrollTop();

        $(".scrolltab__content").each(function () {
            let sectionTop = $(this).offset().top - 130;
            let sectionBottom = sectionTop + $(this).outerHeight();

            if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
                let currentId = $(this).attr("id");
                $(".scrolltab__menu-link").removeClass("active-tabmenu");
                $('.scrolltab__menu-link[href="#' + currentId + '"]').addClass("active-tabmenu");
            }
        });
    });
});

// -----------------------------
// 宇治茶を知る - 宇治茶Q&A
// -----------------------------
$(function () {
    $(window).on("scroll", function () {
        let scrollPos = $(window).scrollTop();

        $(".knowledgeqa-main").each(function () {
            let sectionTop = $(this).offset().top - 160;
            let sectionBottom = sectionTop + $(this).outerHeight();

            if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
                let currentId = $(this).attr("id");
                $(".knowledgeqa-link").removeClass("active-tabmenu");
                $('.knowledgeqa-link[href="#' + currentId + '"]').addClass("active-tabmenu");
            }
        });
    });
});

// -----------------------------
// 宇治茶を知る - 産地茶畑
// -----------------------------
$(function () {
    $(".map__item").each(function (index) {
        let itemId = $(this).data('itemid');

        if (itemId && $('#' + itemId).length) {
            if (itemId === "kyoto") {
                $(this).hover(function () {
                    $(this).find('img').css("box-shadow", "0 0 0 4px #FAC898");
                    $('#kyoto path').css('fill', '#FAC898');
                }, function () {
                    $(this).find('img').css("box-shadow", "none");
                    $('#kyoto path').css('fill', '#34a853');
                });
            } else {
                $(this).hover(
                    function () {
                        $(this).find('img').css("box-shadow", "0 0 0 4px #FAC898");
                        $('#' + itemId).css('fill', '#FAC898');
                    }, function () {
                        $(this).find('img').css("box-shadow", "none");
                        $('#' + itemId).css('fill', '#34a853');
                    }
                );
            }

        }
    });

    $(".location").each(function (index) {
        let itemId = $(this).attr("id");

        if (itemId && $('[data-itemid="' + itemId + '"]').length) {
            if (itemId === "kyoto") {
                $(this).hover(
                    function () {
                        $(this).find('path').css("box-shadow", "0 0 0 4px #FAC898");
                        $('[data-itemid="' + itemId + '"]').find('img').css("box-shadow", "0 0 0 4px #FAC898");
                    }
                    , function () {
                        $(this).find('path').css("box-shadow", "0 0 0 4px #FAC898");
                        $('[data-itemid="' + itemId + '"]').find('img').css("box-shadow", "none");
                    }
                );
            } else {
                $(this).hover(
                    function () {
                        $(this).css("box-shadow", "0 0 0 4px #FAC898");
                        $('[data-itemid="' + itemId + '"]').find('img').css("box-shadow", "0 0 0 4px #FAC898");
                    }
                    , function () {
                        $(this).css("box-shadow", "0 0 0 4px #FAC898");
                        $('[data-itemid="' + itemId + '"]').find('img').css("box-shadow", "none");
                    }
                );
            }

            $(this).on('click', function () {
                $('[data-itemid="' + itemId + '"]').trigger("click");
            });
        }
    });

    $('.open-map-popup').magnificPopup({
        type: 'inline',
        closeMarkup: '<button title="%title%" class="mfp-close custom-close">閉じる<div class="mfp-close__icon"></div></button>',
        callbacks: {
            open: function () {
                $('.mfp-content video').each(function () {
                    this.load();
                    this.currentTime = 0.1;
                });
            },
            close: function () {
                $('video').each(function () {
                    this.pause();
                    $(this)
                    .closest('.popup-map__media-item')       
                    .find('.popup-map__media-iconplay')      
                    .show(); 
                });
            }
        }

    });

    $(document).on('click', '.popup-map__media-iconplay', function () {
        $(this).prev('.map-video').get(0).play();
        $(this).hide();
        $(this).prev('.map-video').attr('controls', 'controls');
    });

    $(document).on('mouseenter', '.map-video', function () {
        $(this).attr('controls', 'controls');
    });

    $(document).on('mouseleave', '.map-video', function () {
        $(this).removeAttr('controls');
    });

    if ($(window).width() <= 919) {
        $(".map-video").each(function () {
            $(this).attr('controls', 'controls');
        });
    }
});

// -----------------------------
// 宇治茶を知る - 茶つみ
// -----------------------------
$(function () {
    $(document).on('click', '.howtopick-play', function () {
        $(this).prev('.howtopick-video').get(0).play();
        $(this).hide();
        $(this).prev('.howtopick-video').attr('controls', 'controls');
    });

    $(document).on('mouseenter', '.howtopick-video', function () {
        $(this).attr('controls', 'controls');
    });

    $(document).on('mouseleave', '.howtopick-video', function () {
        $(this).removeAttr('controls');
    });
});

// -----------------------------
// 宇治茶を知る - 手もみ製法
// -----------------------------
$(function () {
    $(document).on('click', '.process-play', function () {
        $(this).prev('.process-video').get(0).play();
        $(this).hide();
        $(this).prev('.process-video').attr('controls', 'controls');
    });

    $(document).on('mouseenter', '.process-video', function () {
        $(this).attr('controls', 'controls');
    });

    $(document).on('mouseleave', '.process-video', function () {
        $(this).removeAttr('controls');
    });
});

// -----------------------------
// 宇治茶を知る - 宇治茶図書館
// -----------------------------
$(function () {
    $(window).on("scroll", function () {
        let scrollPos = $(window).scrollTop();

        $(".library-main").each(function () {
            let sectionTop = $(this).offset().top - 130;
            let sectionBottom = sectionTop + $(this).outerHeight();

            if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
                let currentId = $(this).attr("id");
                $(".library-link").removeClass("active-tabmenu");
                $('.library-link[href="#' + currentId + '"]').addClass("active-tabmenu");
            }
        });
    });
});

// -----------------------------
// 宇治茶を知る - 茶園の生産サイクル
// -----------------------------
$(function () {

    $('.tabsSeichahoho-btn').on('click', function () {
        $('.tabsSeichahoho-btn').not(this).removeClass('tab-active');
        id = $(this).data('id');
        $(this).addClass('tab-active');


        $('.tabsSeichahoho-content').removeClass('tabs-content-active');
        $('#tabsSeichahoho-content-' + id).addClass('tabs-content-active');

    });

    $(document).on('click', '.seichahoho-play', function () {
        $(this).prev('.seichahoho-video').get(0).play();
        $(this).hide();
        $(this).prev('.seichahoho-video').attr('controls', 'controls');
    });

    $(document).on('mouseenter', '.seichahoho-video', function () {
        $(this).attr('controls', 'controls');
    });

    $(document).on('mouseleave', '.seichahoho-video', function () {
        $(this).removeAttr('controls');
    });

    // popup
    $('.open-ss-popup').magnificPopup({
        type: 'inline',
        closeMarkup: '<button title="%title%" class="mfp-close custom-close">閉じる<div class="mfp-close__icon"></div></button>',
    });
});

// -----------------------------
// 宇治茶を知る - お茶の種類
// -----------------------------
$(function () {

    $('.kinds__tea-item').magnificPopup({
        type: 'image'
    });
});

// -----------------------------
// 宇治茶を知る - 飲める店（宇治茶カフェ）
// -----------------------------
$(function () {
    $('.open-store-popup').magnificPopup({
        type: 'inline',
        closeMarkup: '<button title="%title%" class="mfp-close custom-close">閉じる<div class="mfp-close__icon"></div></button>',
    });
});

// -----------------------------
// 京都府茶業会議所について - 瓶入りドリンク「玉兎」
// -----------------------------
$(function () {
    $('.tamausagi-play').on('click', function () {
        $("#tamausagi-video").get(0).play();
        $(this).attr('controls', 'controls');
        $(this).hide();
    });

    $(document).on('mouseenter', '#tamausagi-video', function () {
        $(this).attr('controls', 'controls');
    });

    $(document).on('mouseleave', '#tamausagi-video', function () {
        $(this).removeAttr('controls');
    });

    if ($(window).width() <= 919) {
        $("#tamausagi-video").each(function () {
            $(this).attr('controls', 'controls');
        });
    }
});

// -----------------------------
// 京都府茶業会議所について - 残留農薬分析結果
// -----------------------------
$(function () {
    $(".page-about-initiative-zanryunoyaku .wp-block-flexible-table-block-table").wrap("<div class='scroll-content js-scrollable'></div>");

    setTimeout(function () {
        new ScrollHint(".js-scrollable", {
            scrollHintIconAppendClass: "scroll-hint-icon-white",
            i18n: {
                scrollable: "スクロールできます",
            },
        });
    }, 100);
});

// -----------------------------
// 会館貸出 - 京都府茶業会館の魅力
// -----------------------------
$(function () {

    $('.floor-details__img').magnificPopup({
        type: 'image'
    });


});

// -----------------------------
// 会館貸出
// -----------------------------
$(function () {

    const selectors = ['.swiper-trainingroom1', '.swiper-trainingroom2', '.swiper-trainingroom3',
        '.swiper-largehall', '.swiper-meetingroom1', '.swiper-meetingroom2', '.swiper-pilotis'];

    selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            new Swiper(element, {
                loop: true,
                autoplay: {
                    delay: 3000,
                },
                centeredSlides: true,
                speed: 1000,
                slidesPerView: 'auto',
                spaceBetween: 40,
                scrollbar: {
                    el: '.swiper-scrollbar',
                },
                breakpoints: {
                    // when window width is >= 390px
                    390: {
                        spaceBetween: 20
                    },
                    // when window width is >= 919px
                    919: {
                        spaceBetween: 40
                    }
                }
            });
        });
    });

    $(document).on('click', '.room-play', function () {
        $(this).prev('.room-video').get(0).play();
        $(this).hide();
        $(this).prev('.room-video').attr('controls', 'controls');
    });

    $(document).on('mouseenter', '.room-video', function () {
        $(this).attr('controls', 'controls');
    });

    $(document).on('mouseleave', '.room-video', function () {
        $(this).removeAttr('controls');
    });
});

// -----------------------------
// 会館貸出 - 会館利用申込
// -----------------------------
$(function () {
    // show / hide chagyo and ujicha options (confirm screen)
    const rbRental = document.getElementById('cf7msm_rbRental');
    if (rbRental) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    const elem = $('#cf7msm_rbRental').text();

                    updateConfirmFields();

                    if (elem === "京都府茶業会館") {
                        $('.chagyo-options').css('display', 'flex');
                        $('.ujicha-options').hide();
                    } else {
                        $('.chagyo-options').hide();
                        $('.ujicha-options').css('display', 'flex');
                    }

                    observer.disconnect();
                }
            });
        });

        observer.observe(rbRental, { childList: true });
    }

    // replace , to line break on selected checkbox options (confirm screen)
    const cbChagyoRoom = document.getElementById('cf7msm_cbChagyoRoom');
    if (cbChagyoRoom) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    const elem = cbChagyoRoom.textContent;

                    const formatted = elem.replace(/,\s*/g, '\n');

                    $('#cf7msm_cbChagyoRoom').text(formatted);

                    observer.disconnect();
                }
            });
        });

        observer.observe(cbChagyoRoom, { childList: true });
    }

    const cbChagyoEquip = document.getElementById('cf7msm_cbChagyoEquip');
    if (cbChagyoEquip) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    const elem = cbChagyoEquip.textContent;

                    const formatted = elem.replace(/,\s*/g, '\n');

                    $('#cf7msm_cbChagyoEquip').text(formatted);

                    observer.disconnect();
                }
            });
        });

        observer.observe(cbChagyoEquip, { childList: true });
    }

    const cbUjichaRoom = document.getElementById('cf7msm_cbUjichaRoom');
    if (cbUjichaRoom) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    const elem = cbUjichaRoom.textContent;

                    const formatted = elem.replace(/,\s*/g, '\n');

                    $('#cf7msm_cbUjichaRoom').text(formatted);

                    observer.disconnect();
                }
            });
        });

        observer.observe(cbUjichaRoom, { childList: true });
    }

    const cbUjichaEquip3 = document.getElementById('cf7msm_cbUjichaEquip3');
    if (cbUjichaEquip3) {
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    const elem = cbUjichaEquip3.textContent;

                    const formatted = elem.replace(/,\s*/g, '\n');

                    $('#cf7msm_cbUjichaEquip3').text(formatted);

                    observer.disconnect();
                }
            });
        });

        observer.observe(cbUjichaEquip3, { childList: true });
    }




    function updateConfirmFields() {
        const selected = $('#cf7msm_rbRental').text();
        let rooms = '';
        let equipments = '';

        if (selected === '京都府茶業会館') {
            rooms = $('#cf7msm_cbChagyoRoom').text() || '';
            equipments = $('#cf7msm_cbChagyoEquip').text() || '';
        } else if (selected === '宇治茶会館') {
            rooms = $('#cf7msm_cbUjichaRoom').text() || '';
            equipments = [
                $('#cf7msm_cbUjichaEquip1').text() + " " + $('#cf7msm_select-wirelessmic').text() + "," +
                $('#cf7msm_cbUjichaEquip2').text() + " " + $('#cf7msm_select-pinmic').text() + "," +
                $('#cf7msm_cbUjichaEquip3').text() + "," +
                $('#cf7msm_cbUjichaEquip4').text() + " " + $('#cf7msm_select-hoiro').text() + "," +
                $('#cf7msm_cbUjichaEquip5').text(),
            ].filter(Boolean).join('\n');
        }

        $('[name="confirm-rooms"]').val(rooms);
        $('[name="confirm-equipments"]').val(equipments);
    }

});

// -----------------------------
// 会館貸出 - 京都府茶業会館・宇治茶会館
// -----------------------------
$(function () {
    const hash = decodeURIComponent(window.location.hash);
    if (hash === '#calendar') {
        const target = $('#calendar');
        if (target.length) {
            const position = target[0].getBoundingClientRect().top + window.pageYOffset - 120;
            window.scrollTo({
                top: position,
                behavior: 'auto' 
              });
        }
    }
});


// -----------------------------
// 宇治茶を楽しもう  - 社会
// -----------------------------
$(function () {
    $('.open-where-popup').magnificPopup({
        type: 'inline',
        closeMarkup: '<button title="%title%" class="mfp-close custom-close">閉じる<div class="mfp-close__icon"></div></button>',
    });
});

// -----------------------------
// 宇治茶を楽しもう  - 家庭科
// -----------------------------
$(function () {
    $('.tabs2HomeEco-btn').on('click', function () {
        $('.tabs2HomeEco-btn').not(this).removeClass('tab-active');
        id = $(this).data('id');
        $(this).addClass('tab-active');


        $('.tabs2HomeEco-content').removeClass('tabs2-content-active');
        $('#tabs2HomeEco-content-' + id).addClass('tabs2-content-active');

    });

    $('.tabs2Tea-btn').on('click', function () {
        $('.tabs2Tea-btn').not(this).removeClass('tab-active');
        id = $(this).data('id');
        $(this).addClass('tab-active');


        $('.tabs2Tea-content').removeClass('tabs2-content-active');
        $('#tabs2Tea-content-' + id).addClass('tabs2-content-active');

    });

    $('.homeEco-img').magnificPopup({
        type: 'image'
    });

    // activate tab and scroll to anchor link
    const hash = decodeURIComponent(window.location.hash);
    if (hash === '#手もみを見学してみよう') {
        $('#tab1').trigger('click');
    } else if (hash === '#碾茶（抹茶）ができるまで') {
        $('#tab2').trigger('click');
        $('.subtab1').trigger('click');
    } else if (hash === '#玉露・煎茶ができるまで') {
        $('#tab2').trigger('click');
        $('.subtab2').trigger('click');
    }

    if ($(hash).length) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top - 100
        }, 300, 'swing');
    }

    $('.btn-toTab').on('click', function (e) {
        e.preventDefault();
        const hash = decodeURIComponent(this.hash);

        if (hash === '#手もみを見学してみよう') {
            $('#tab1').trigger('click');
        } else if (hash === '#碾茶（抹茶）ができるまで') {
            $('#tab2').trigger('click');
            $('.subtab1').trigger('click');
        } else if (hash === '#玉露・煎茶ができるまで') {
            $('#tab2').trigger('click');
            $('.subtab2').trigger('click');
        }

        if ($(hash).length) {
            $('html, body').animate({
                scrollTop: $(hash).offset().top - 100
            }, 300, 'swing');
        }

        history.replaceState(null, null, hash);

    });
});

document.addEventListener("DOMContentLoaded", function () {
    const dayInners = Array.from(document.querySelectorAll('.day__inner'));
    const offset = 24;
    const daysPerWeek = 7;

    // 空白セル（data__not）の数をカウント（最初の週の空白日数）
    const blanks = document.querySelectorAll('tbody tr:first-child td.data__not').length;

    // .day__inner の前に空白分を加味して、週単位で正しく切る
    const totalCells = blanks + dayInners.length;
    const totalWeeks = Math.ceil(totalCells / 7);

    for (let week = 0; week < totalWeeks; week++) {
        const startIndex = Math.max(0, week * 7 - blanks); // 空白分補正
        const weekGroup = dayInners.slice(startIndex, startIndex + 7);

        const seen = {};
        let currentTop = 32;

        // ID取得
        const allSpans = weekGroup.flatMap(container =>
            Array.from(container.querySelectorAll('span[id]'))
        );

        const uniqueIds = [];
        allSpans.forEach(span => {
            const id = span.getAttribute('id');
            if (!uniqueIds.includes(id)) uniqueIds.push(id);
        });

        // IDごとにtopを割当
        uniqueIds.forEach(id => {
            seen[id] = currentTop;
            currentTop += offset;
        });

        // 適用
        weekGroup.forEach(container => {
            let maxBottom = 0;
            const spans = container.querySelectorAll('span[id]');

            spans.forEach(span => {
                const id = span.getAttribute('id');
                const top = seen[id];
                span.style.position = 'absolute';
                span.style.top = `${top}px`;

                const spanHeight = span.offsetHeight || 22;
                const bottom = top + spanHeight;
                maxBottom = Math.max(maxBottom, bottom);
            });

            // day__inner の高さ調整
            if (maxBottom > 0) {
                container.style.height = `${maxBottom + 8}px`;
            }
        });
    }
});